import React, { useEffect, useState } from "react";
import { coachviewprofile } from "../../../../../services/coach";
import {
  adminexternaltourlist,
  externaltourdelete,
  externaltourlist,
} from "../../../../../services/common";
import { AgGridReact } from "ag-grid-react";
import dotracking from "../../../../trackinglogs";
import trackobj from "../../../../trackingpages.json";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import { toast } from "react-toastify";
import Swal from "sweetalert2";
import exportUrl from "../../../../../exportUtl";
import { hidetourlist } from "../../../../../services/superadmin";

export const ListExternalTour = () => {
  const [filterProduct, setFilterProduct] = useState([]);
  const navigate = useNavigate();
const userRole = localStorage.getItem("Role");

  const columnDefs = [
    {
      headerName: "Actions",
      width: 220,
      field: "id",
      resizable: true,
      filter: false,
      cellRenderer: function (params) {
        return (
          <div className="text-center">
            <a
              onClick={() => viewdet(params.value, params)}
              title="View Tournament"
              className="btn-sm btn-secondary me-2"
            >
              <i className="fa fa-eye fa-lg"></i>
            </a>

            {params.data.sports_type !== "ATHLETICS" &&
              localStorage.getItem("Role") === "7" && (
                <a
                  onClick={() => teamdet(params.value, params)}
                  title="Create Team List"
                  className="btn-sm btn-warning me-2"
                >
                  <i className="fa fa-list fa-lg"></i>
                </a>
              )}
            <a
              title="Upload Photos"
              onClick={() => photodet(params.value, params)}
              className="btn-sm btn-export me-2"
            >
              <i className="fa fa-picture-o fa-lg"></i>
            </a>
            <a
              title="Download Tournament Report"
              onClick={() => repdet(params.value, params)}
              className="btn-sm btn-import me-2"
            >
              <i className="fa fa-download fa-lg"></i>
            </a>

            <a
              title="Upload Achievement"
              onClick={() => achdet(params.value, params)}
              className="btn-sm btn-gray me-2"
            >
              <i className="fa fa-upload fa-lg"></i>
            </a>

            {localStorage.getItem("Role") === "1" && (
              <a
                title="Delete External Tournament"
                onClick={() => deletetour(params.value, params)}
                className="btn-sm btn-danger me-2"
              >
                <i className="fa fa-trash fa-lg"></i>
              </a>
            )}
          </div>
        );
      },
    },
    {
      headerName: "Tournament Name",
      width: 300,
      field: "meet_name",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },

    {
      headerName: "Location",
      width: 170,
      field: "location",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Start Date",
      width: 150,
      field: "start_date",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
      cellRenderer: function (params) {
        if (params.value !== null) {
          return moment(params.value).format("DD-MM-yyyy");
        }
      },
    },
    {
      headerName: "End Date",
      width: 150,
      field: "end_date",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
      cellRenderer: function (params) {
        if (params.value !== null) {
          return moment(params.value).format("DD-MM-yyyy");
        }
      },
    },

    {
      headerName: "Type",
      width: 170,
      field: "meet_type_name",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Sports",
      width: 150,
      field: "sports_type",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Age Categories",
      width: 150,
      field: "categories",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "State",
      width: 150,
      field: "statename",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },

    {
      headerName: "District",
      width: 150,
      field: "districtname",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
     {
      headerName: "Hide Status",
      width: 130,
      field: "display_status",
      resizable: true,
      hide: userRole != 1,
      cellStyle: { textAlign: "left" },
      cellRenderer: function (params) {
        return (
          <div className="text-center">
            <label className="custom-switch mb-0">
              <input
                type="checkbox"
                name="custom-switch-checkbox"
                className="custom-switch-input"
                checked={params.value === 1 ? true : false}
                onChange={() => hidetour(params.value, params)}
              />

              <span className="custom-switch-indicator"></span>
            </label>
          </div>
        );
      },
    },
  ];
   function hidetour(sid, tdata) {
      Swal.fire({
        text: sid == 1 ? "Are you sure want to hide the external tournament?" : "Are you sure want to unhide the external tournament?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#ac0404",
        cancelButtonColor: "#6259ca",
        confirmButtonText: "Yes",
        allowOutsideClick: false,
      }).then((result) => {
        if (result.isConfirmed) {
          const temp = new FormData();
          temp.append("table_type", 2);
          temp.append("id", tdata.data.id);
          let sdata = ""
          if(sid == 1){
            sdata="hide"
          }else {
            sdata="unhide"
          }
          dotracking(
            sdata + " in external tournament list for " +
              tdata.data.meet_name +
              " (" +
              tdata.data.id +
              ") tournament $$ " +
              trackobj.listextheading
          );
          hidetourlist(temp).then((response) => {
            if (response.status === true) {
              listall();
              toast.success(response.message);
            }
          });
        }
      });
    }

  function viewdet(tid, tdata) {
    dotracking(
      "view icon in external tournament list for " +
        tdata.data.meet_name +
        " (" +
        tid +
        ") tournament $$ " +
        trackobj.viewexttourheading
    );
    if (localStorage.getItem("Role") === "1") {
      navigate("/superadmin/externaltournamentdetails/" + tid);
    } else if (localStorage.getItem("Role") === "3") {
      navigate("/cityregional/externaltournamentdetails/" + tid);
    } else if (localStorage.getItem("Role") === "7") {
      navigate("/coach/externaltournamentdetails/" + tid);
    }
  }

  function teamdet(tid, tdata) {
    if (localStorage.getItem("Role") === "1") {
      dotracking(
        "team icon in external tournament list for " +
          tdata.data.meet_name +
          " (" +
          tid +
          ") tournament $$ " +
          trackobj.teamlistheading
      );
      navigate("/superadmin/externalteamlist/" + tid);
    } else if (localStorage.getItem("Role") === "7") {
      dotracking(
        "team icon in external tournament list for " +
          tdata.data.meet_name +
          " (" +
          tid +
          ") tournament $$ " +
          trackobj.teamlistheading
      );
      navigate("/coach/externalteamlist/" + tid);
    }
  }

  function photodet(tid, tdata) {
    dotracking(
      "upload photo icon in external tournament list for " +
        tdata.data.meet_name +
        " (" +
        tid +
        ") tournament $$ " +
        trackobj.photouploadheading
    );
    if (localStorage.getItem("Role") === "1") {
      navigate("/superadmin/externalphotoupload/" + tid);
    } else if (localStorage.getItem("Role") === "3") {
      navigate("/cityregional/externalphotoupload/" + tid);
    }  else if (localStorage.getItem("Role") === "7") {
      navigate("/coach/externalphotoupload/" + tid);
    }
  }

  function repdet(rid, rdata) {
    // if (localStorage.getItem("Role") === "4" || localStorage.getItem("Role") === "7") {
    dotracking(
      "download tournament report icon in external tournament list for " +
        rdata.data.meet_name +
        " (" +
        rid +
        ") tournament $$ " +
        trackobj.externaltourlist
    );
    window.open(exportUrl + "export-tournament-report/" + rid + "/2", "_blank");
    // }
  }

  function achdet(tid, tdata) {
    dotracking(
      "upload achievement icon in external tournament list for " +
        tdata.data.meet_name +
        " (" +
        tid +
        ") tournament $$ " +
        trackobj.achieveuploadheading
    );
    if (localStorage.getItem("Role") === "1") {
      navigate("/superadmin/externalachievementsupload/" + tid);
    } else if (localStorage.getItem("Role") === "3") {
      navigate("/cityregional/externalachievementsupload/" + tid);
    }  else if (localStorage.getItem("Role") === "7") {
      navigate("/coach/externalachievementsupload/" + tid);
    }
  }

  function deletetour(tid, tdata) {
    if (localStorage.getItem("Role") === "1") {
      dotracking(
        "delete icon in external tournament list for " +
          tdata.data.meet_name +
          " (" +
          tid +
          ") tournament $$ " +
          trackobj.listextheading
      );
      Swal.fire({
        title: "Are you sure want to delete?",
        showCancelButton: true,
        confirmButtonColor: "#d71635",
        confirmButtonText: "Ok",
        allowOutsideClick: false,
      }).then((result) => {
        if (result.isConfirmed) {
          externaltourdelete(tid).then((response) => {
            if (response.status === true) {
              listall();
              toast.success(response.message);
            }
          });
        }
      });
    }
  }

  useEffect(() => {
    listall();
  }, []);

  function listall() {
    if (localStorage.getItem("Role") === "7") {
      coachviewprofile().then((res) => {
        if (res.status === true) {
          const temp = new FormData();
          temp.append("school_id", res.data.school_id);
          externaltourlist(temp).then((response) => {
            if (response.status === true) {
              setFilterProduct(response.data.tournaments);
            }
          });
        }
      });
    } else if (localStorage.getItem("Role") === "3"){
      const temp = new FormData();
      temp.append("school_id", localStorage.getItem("UID"));
      adminexternaltourlist(temp).then((response) => {
        if (response.status === true) {
          setFilterProduct(response.data.tournaments);
        }
      });
    }else{
      const temp = new FormData();
      temp.append("school_id", 0);
      adminexternaltourlist(temp).then((response) => {
        if (response.status === true) {
          setFilterProduct(response.data.tournaments);
        }
      });
    }
  }

  return (
    <div className="side-app">
      <div className="page-header">
        <div className="breadcrumb">
          <h4 className="mb-0">External Tournament Lists</h4>
        </div>
        <ol className="breadcrumb">
          <li className="breadcrumb-item">
            <a>Tournament</a>
          </li>
          <li className="breadcrumb-item active" aria-current="page">
            External Tournament Lists
          </li>
        </ol>
      </div>

      <div className="row">
        <div className="col-12">
          <form className="card mt-0">
            <div className="card-body">
              <div className="ag-theme-alpine ag-style">
                <AgGridReact
                  columnDefs={columnDefs}
                  rowData={filterProduct}
                  pagination="true"
                  paginationPageSize="10"
                  sortingOrder={["asc", "desc"]}
                  suppressExcelExport={true}
                  suppressDragLeaveHidesColumns={true}
                />
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};
